import { TNullable } from '@rw1/utilities/type'
import { useEffect, useMemo, useState } from 'react'

const useDocumentDimensions = (): {
  height: TNullable<number>
  width: TNullable<number>
} => {
  const [height, setHeight] = useState<number | null>(null)
  const [width, setWidth] = useState<number | null>(null)

  const resizeObserver = useMemo(
    () =>
      new ResizeObserver(([maybeDocument]) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!maybeDocument) {
          return
        }

        setHeight(maybeDocument.target.clientHeight)
        setWidth(maybeDocument.target.clientWidth)
      }),
    [],
  )

  useEffect(() => {
    resizeObserver.observe(document.body)

    return () => resizeObserver.disconnect()
  }, [resizeObserver])

  return { height, width }
}

export { useDocumentDimensions }
